unit UnitLogin;

interface

uses System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms,  WEBLib.Dialogs,
     Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Storage, System.DateUtils, WEBLib.WebCtrls,
     VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, System.TypInfo,
     VCL.TMSFNCToolBar, XData.Web.Client, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, Vcl.Imaging.GIFImg,
     WebBasis, VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, WebBasis2;

type
  TLoginForm = class(TfrmWebBasis)
    tmrLoginStart: TTimer;
    pnlLogin: TPanel;
    editUsername: TEdit;
    editPassword: TEdit;
    cbxUserMerken: TCheckBox;
    btnLogin: TButton;
    lbBenutzer: TLabel;
    lbPasswort: TLabel;
    cbxSprache: TComboBox;
    WebLabel3: TLabel;
    WebButton1: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure editUsernameChange(Sender: TObject);

    procedure WebFormResize(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure cbxSpracheChange(Sender: TObject);
    //
    [async] procedure tmrLoginStartTimer(Sender: TObject); async;
    [async] procedure btnLoginClick(Sender: TObject); async;
    [async] procedure SprachDaten_Laden( iID_Sprache : Integer ); async;
    [async] procedure Form_Uebersetzen; async;
    procedure editUsernameKeyPress(Sender: TObject; var Key: Char);
    procedure editPasswordKeyPress(Sender: TObject; var Key: Char);
    [async] procedure WebButton1Click(Sender: TObject); async;
    //


  private


  public

  protected procedure LoadDFMValues; override; end;


var LoginForm: TLoginForm;

implementation

uses UnitMain, GlobalWeb, SpediFucsDatenmodul, GetBarcode;

{$R *.dfm}

//====================================================================================================================//

procedure TLoginForm.btnLoginClick(Sender: TObject);
var sLoginCheck: String;

begin


  sLoginCheck := await( frmMainForm.XDataLogin(editUSername.Text, editPassword.Text));

//  Showmessage(LoginCheck);

  If sLoginCheck = 'Success' then
    Begin

      // Briefly show successful login message
      //btnLogin.Caption := 'Anmeld.OK';

      //  asm await sleep(500); end;

      self.iID_Sprache := TCoreGuiObj(cbxSprache.Items.Objects[cbxSprache.ItemIndex] ).ID;

      // Process Remembering
      if cbxUserMerken.Checked then
      begin
        frmMainForm.Remember := True;
        TLocalStorage.SetValue('Login.Username', editUsername.Text);
        TLocalStorage.SetValue('Login.JWT', frmMainForm.JWT);
        TLocalStorage.SetValue('Login.Expiry', FloatToStr(frmMainForm.JWT_Expiry));
        TLocalStorage.SetValue('Login.OptSpeichern', 'JA' );
        TLocalStorage.SetValue('Login.Sprache', IntToStr(iID_Sprache) );
      end
      else
      begin
        frmMainForm.Remember := False;
        TLocalStorage.RemoveKey('Login.Username');
        TLocalStorage.RemoveKey('Login.JWT');
        TLocalStorage.RemoveKey('Login.Expiry');
        TLocalStorage.RemoveKey('Login.OptSpeichern');
      end;

      frmMainForm.Set_BenutzerAktiv( True );
      frmMainForm.LoadForm('frmMainForm');

      window.history.pushState(frmMainForm.CaptureState, '', frmMainForm.URL);
      frmMainForm.Position      := window.history.length;
      frmMainForm.StartPosition := frmMainForm.Position - 1;

      frmMainForm.SprachDaten_Laden( self.iID_Sprache );;
      frmMainForm.iID_Sprache := self.iID_Sprache;


    end  //If LoginCheck = 'Success' then

  Else

    Begin
      frmMainForm.Set_BenutzerAktiv( False );
      MessageDlg( Transl(50,'Die Anmeldung ist nicht möglich'), mtInformation, [mbOK]);
    End;


end;

//====================================================================================================================//

procedure TLoginForm.WebFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
begin

EXIT;

  If (Key = VK_RETURN) and (trim(editUsername.Text) <> '')  and (Trim(editPassword.Text) <> '')  then
       btnLoginClick(Sender)
  Else editUsernameChange(Sender);

end;

//====================================================================================================================//

procedure TLoginForm.WebFormResize(Sender: TObject);
begin

  pnlLogin.Left := Trunc( (self.Width/2)  - (pnlLogin.Width/2) );
  pnlLogin.Top  := Trunc( (self.Height/2) - (pnlLogin.Height/2) );

end;

//====================================================================================================================//

procedure TLoginForm.WebButton1Click(Sender: TObject);
var sCode : String;
    aModalResult : TModalResult;
begin
  inherited;

  aModalResult := await( TModalResult, Get_Barcode( sCode ) );


  If aModalResult = mrOK then Showmessage('OK '+sCode)
  Else Showmessage('Cancel '+sCode);

end;

procedure TLoginForm.WebButton2Click(Sender: TObject);
begin

end;

//====================================================================================================================//

procedure TLoginForm.WebFormCreate(Sender: TObject);
begin

  tmrLoginStart.Enabled := True;

end;

//====================================================================================================================//

procedure TLoginForm.cbxSpracheChange(Sender: TObject);
//var iID_Sprache : Integer;
begin

  iID_Sprache := TCoreGuiObj(cbxSprache.Items.Objects[cbxSprache.ItemIndex] ).ID;

  SprachDaten_Laden( self.iID_Sprache );


end;

//====================================================================================================================//

procedure TLoginForm.editPasswordKeyPress(Sender: TObject; var Key: Char);
begin
  inherited;

   If Key = chr(13) then btnLoginClick(Sender);

end;

procedure TLoginForm.editUsernameChange(Sender: TObject);
begin

  if (Trim(editUsername.Text) = '') and (Trim(editPassword.Text) = '') then
  begin
    btnLogin.Enabled := False;

  end
  else if (Trim(editUsername.Text) = '') then
  begin
    btnLogin.Enabled := False;

  end
  else if (Trim(editPassword.Text) = '') then
  begin
    btnLogin.Enabled := False;

  end
  else
  begin
    btnLogin.Enabled := True;

  end;
end;

//====================================================================================================================//

procedure TLoginForm.editUsernameKeyPress(Sender: TObject; var Key: Char);
begin
  inherited;
  If Key = chr(13) then editPassword.SetFocus
end;

//====================================================================================================================//

procedure TLoginForm.tmrLoginStartTimer(Sender: TObject);
var sLastUser, sTmp, CheckForm, CheckSubForm, sDaten, sSQL : String;
    LoggedIn, CheckForms, UserPass : Boolean;
    aSL, aSL_Daten : TStringList;
    aGuiObj :  TCoreGuiObj;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    aArray : TArray<string>;
    i, iIdx, iID_Sprache, iAnz : Integer;
begin

  tmrLoginStart.Enabled := False;
  LoggedIn   := False;
  CheckForms := False;
  UserPass   := False;

//  editUsername.Text := '';
//  editPassword.Text := 'geheim';


  // Check for valid state information
  CheckForm    := TLocalStorage.GetValue('Login.CurrentForm');
  CheckSubform := TLocalStorage.GetValue('Login.CurrentSubForm');
  asm if (window.ValidForms.includes(CheckForm) && window.ValidSubForms.includes(CheckSubForm)) { CheckForms = true; } end;

  if (CheckForms = True) then
  begin
    if (CheckForm <> 'LoginForm') then
    begin
      if (TLocalStorage.GetValue('Login.Expiry') <> '') then
      begin
        frmMainForm.JWT_Expiry := StrToFloat(TLocalStorage.GetValue('Login.Expiry'));
        if frmMainForm.JWT_Expiry > (TTimeZone.Local.ToUniversalTime(Now) + 60/86400) then
        begin
          LoggedIn := True;
          frmMainForm.LogAction('AutoLogin - JWT Time Remaining: '+IntToStr(SecondsBetween(frmMainForm.JWT_Expiry, TTimeZone.Local.ToUniversalTime(Now)))+'s', False);
          frmMainForm.ProcessJWT(TLocalStorage.GetValue('Login.JWT'));
          frmMainForm.LoadForm(CheckForm);
          window.history.pushState(frmMainForm.CaptureState, '', frmMainForm.URL);
          frmMainForm.Position := window.history.length;
          frmMainForm.StartPosition := frmMainForm.Position - 1;
        end
        else
        begin
          frmMainForm.Logout('AutoLogin - JWT Expired');
        end;
      end;
    end;
  end;

  // Logging in Manually
  If not(LoggedIn) then
    Begin

      btnLogin.Caption := 'Anmelden';

      sTmp := TLocalStorage.GetValue('Login.OptSpeichern');
      If sTmp = 'JA' then
           cbxUserMerken.Checked := True
      Else cbxUserMerken.Checked := False;

      sTmp := TLocalStorage.GetValue('Login.Sprache');
      If sTmp ='' then sTmp := '0';
      iID_Sprache := StrToIntDef(sTmp,0);

      sLastUser :=  TLocalStorage.GetValue('Login.Username');
      If sLastUser <> '' then
        Begin
         editUsername.Text := sLastUser;
         editUsernameChange(Sender);
         UserPass := True;
        End
      Else
        Begin
          editUsernameChange(Sender);
        End;


      // Sprachen holen...
      If frmMainForm.XDataConn.Connected then
        Begin

          ClientConn := TXDataWebClient.Create(nil);
          ClientConn.Connection := frmMainForm.XDataConn;
            Response := await( ClientConn.RawInvokeAsync('ISystemService.GetBenutzerSprachen', [0] ) );
            Blob := Response.Result;
            asm sDaten = await Blob.text(); end;
          ClientConn.Free;

          sDaten := await( Crypt( sDaten ));

          aSL_Daten := TStringList.Create;
          aSL_Daten.Text := sDaten;
          aSL := TStringList.Create;
          iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

          cbxSprache.Items.Clear;
          aGuiObj :=  TCoreGuiObj.Create;
          aGuiObj.ID :=0;
          aGuiObj.Bezeichnung := 'Deutsch';
          cbxSprache.Items.AddObject( aGuiObj.Bezeichnung , aGuiObj );

          iIdx := 0;
          For i := 2 to aSL.Count -1 Do
            Begin
              sTmp := aSL[i];
              aArray := sTmp.Split([';']);
              aGuiObj :=  TCoreGuiObj.Create;
              aGuiObj.ID := StrToIntDef( aArray[0],0 );
              aGuiObj.Bezeichnung := aArray[1];
              cbxSprache.Items.AddObject( aArray[1], aGuiObj );
              If iID_Sprache= aGuiObj.ID  then iIdx := cbxSprache.Items.Count-1;
            End;

          aSL_Daten.Free;
          aSL.Free;
          cbxSprache.ItemIndex := iIdx;

          If iID_Sprache > 0 then
            Begin
               SprachDaten_Laden( iID_Sprache );
               self.Form_Uebersetzen;
            End;

        End;


      // Show the login page
      asm await sleep(500); end;

      // Try to set the focus to one of these two elements
      If UserPass then
           editPassword.SetFocus
      Else editUsername.SetFocus;


    End;

  frmMainForm.PreventCompilerHint(CheckSubForm);

end;


//====================================================================================================================//

procedure TLoginForm.SprachDaten_Laden( iID_Sprache : Integer );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp : String;
    aSL : TStringList;
    aStream : TStream;
    i : Integer;
    aArray : TArray<string>;
begin

  If not WaitMessage.Showing then WaitMessage.Show;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', ['LOGIN',iID_Sprache] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL := TStringList.Create;
  aSL.Text := await( Crypt( sDaten)) ;

  tabSprachDaten.Close;
  tabSprachDaten.Open;

  If aSL.Count > 2 then
    For i := 2 to aSL.Count -1 Do
        Begin
         sTmp := aSL[i];
          aArray := sTmp.Split([';']);
          tabSprachDaten.Append;
          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
          tabSprachDaten.Post;
        End;

  aSL.Free;


  Form_Uebersetzen;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TLoginForm.Form_Uebersetzen;
begin

  console.Log( 'Form_Uebersetzen in LoginForm');

  If not tabSprachDaten.Active then Exit;

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbBenutzer.Caption := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 20, [] ) then lbPasswort.Caption := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 30, [] ) then btnLogin.Caption   := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 40, [] ) then cbxUserMerken.Caption   := tabSprachDatenBEGRIFF_UEB.AsString;

end;

//====================================================================================================================//

procedure TLoginForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlLogin := TPanel.Create(Self);
  lbBenutzer := TLabel.Create(Self);
  lbPasswort := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  editUsername := TEdit.Create(Self);
  editPassword := TEdit.Create(Self);
  cbxUserMerken := TCheckBox.Create(Self);
  btnLogin := TButton.Create(Self);
  cbxSprache := TComboBox.Create(Self);
  WebButton1 := TButton.Create(Self);
  tmrLoginStart := TTimer.Create(Self);

  pnlLogin.BeforeLoadDFMValues;
  lbBenutzer.BeforeLoadDFMValues;
  lbPasswort.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  editUsername.BeforeLoadDFMValues;
  editPassword.BeforeLoadDFMValues;
  cbxUserMerken.BeforeLoadDFMValues;
  btnLogin.BeforeLoadDFMValues;
  cbxSprache.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WaitMessage.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  tmrLoginStart.BeforeLoadDFMValues;
  try
    Width := 437;
    Height := 278;
    Color := 16776441;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    FormContainer := 'appcontent';
    Visible := True;
    SetEvent(Self, 'OnKeyDown', 'WebFormKeyDown');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlLogin.SetParentComponent(Self);
    pnlLogin.Name := 'pnlLogin';
    pnlLogin.Left := 56;
    pnlLogin.Top := 36;
    pnlLogin.Width := 292;
    pnlLogin.Height := 197;
    pnlLogin.ChildOrder := 6;
    pnlLogin.Color := 12021811;
    pnlLogin.TabOrder := 0;
    lbBenutzer.SetParentComponent(pnlLogin);
    lbBenutzer.Name := 'lbBenutzer';
    lbBenutzer.Tag := 10;
    lbBenutzer.Left := 19;
    lbBenutzer.Top := 49;
    lbBenutzer.Width := 66;
    lbBenutzer.Height := 16;
    lbBenutzer.Caption := 'Benutzer';
    lbBenutzer.Font.Charset := DEFAULT_CHARSET;
    lbBenutzer.Font.Color := clWhite;
    lbBenutzer.Font.Height := -13;
    lbBenutzer.Font.Name := 'Verdana';
    lbBenutzer.Font.Style := [fsBold];
    lbBenutzer.HeightPercent := 100.000000000000000000;
    lbBenutzer.ParentFont := False;
    lbBenutzer.WidthPercent := 100.000000000000000000;
    lbPasswort.SetParentComponent(pnlLogin);
    lbPasswort.Name := 'lbPasswort';
    lbPasswort.Tag := 20;
    lbPasswort.Left := 19;
    lbPasswort.Top := 75;
    lbPasswort.Width := 67;
    lbPasswort.Height := 16;
    lbPasswort.Caption := 'Passwort';
    lbPasswort.Font.Charset := DEFAULT_CHARSET;
    lbPasswort.Font.Color := clWhite;
    lbPasswort.Font.Height := -13;
    lbPasswort.Font.Name := 'Verdana';
    lbPasswort.Font.Style := [fsBold];
    lbPasswort.HeightPercent := 100.000000000000000000;
    lbPasswort.ParentFont := False;
    lbPasswort.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(pnlLogin);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 19;
    WebLabel3.Top := 13;
    WebLabel3.Width := 59;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Sprache';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWhite;
    WebLabel3.Font.Height := -13;
    WebLabel3.Font.Name := 'Verdana';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    editUsername.SetParentComponent(pnlLogin);
    editUsername.Name := 'editUsername';
    editUsername.Left := 116;
    editUsername.Top := 46;
    editUsername.Width := 150;
    editUsername.Height := 22;
    editUsername.ElementFont := efCSS;
    editUsername.HeightPercent := 100.000000000000000000;
    editUsername.TextHint := 'Username';
    editUsername.WidthPercent := 100.000000000000000000;
    SetEvent(editUsername, Self, 'OnChange', 'editUsernameChange');
    SetEvent(editUsername, Self, 'OnKeyPress', 'editUsernameKeyPress');
    editPassword.SetParentComponent(pnlLogin);
    editPassword.Name := 'editPassword';
    editPassword.Left := 116;
    editPassword.Top := 74;
    editPassword.Width := 150;
    editPassword.Height := 22;
    editPassword.ChildOrder := 1;
    editPassword.ElementClassName := 'h6 -small';
    editPassword.ElementFont := efCSS;
    editPassword.HeightPercent := 100.000000000000000000;
    editPassword.PasswordChar := '*';
    editPassword.TextHint := 'Password';
    editPassword.WidthPercent := 100.000000000000000000;
    SetEvent(editPassword, Self, 'OnChange', 'editUsernameChange');
    SetEvent(editPassword, Self, 'OnKeyPress', 'editPasswordKeyPress');
    cbxUserMerken.SetParentComponent(pnlLogin);
    cbxUserMerken.Name := 'cbxUserMerken';
    cbxUserMerken.Tag := 40;
    cbxUserMerken.Left := 19;
    cbxUserMerken.Top := 158;
    cbxUserMerken.Width := 174;
    cbxUserMerken.Height := 23;
    cbxUserMerken.Cursor := crHandPoint;
    cbxUserMerken.Caption := 'Benutzer merken';
    cbxUserMerken.Checked := True;
    cbxUserMerken.ChildOrder := 4;
    cbxUserMerken.Font.Charset := DEFAULT_CHARSET;
    cbxUserMerken.Font.Color := clWhite;
    cbxUserMerken.Font.Height := -13;
    cbxUserMerken.Font.Name := 'Verdana';
    cbxUserMerken.Font.Style := [];
    cbxUserMerken.HeightStyle := ssAuto;
    cbxUserMerken.HeightPercent := 100.000000000000000000;
    cbxUserMerken.ParentFont := False;
    cbxUserMerken.State := cbChecked;
    cbxUserMerken.WidthPercent := 100.000000000000000000;
    btnLogin.SetParentComponent(pnlLogin);
    btnLogin.Name := 'btnLogin';
    btnLogin.Tag := 30;
    btnLogin.Left := 116;
    btnLogin.Top := 110;
    btnLogin.Width := 150;
    btnLogin.Height := 32;
    btnLogin.Cursor := crHandPoint;
    btnLogin.Caption := 'Anmelden';
    btnLogin.ChildOrder := 6;
    btnLogin.ElementClassName := 'btn btn-warning btn-sm';
    btnLogin.ElementFont := efCSS;
    btnLogin.Enabled := False;
    btnLogin.HeightPercent := 100.000000000000000000;
    btnLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogin, Self, 'OnClick', 'btnLoginClick');
    cbxSprache.SetParentComponent(pnlLogin);
    cbxSprache.Name := 'cbxSprache';
    cbxSprache.Left := 116;
    cbxSprache.Top := 10;
    cbxSprache.Width := 150;
    cbxSprache.Height := 24;
    cbxSprache.Cursor := crHandPoint;
    cbxSprache.ElementClassName := 'form-select';
    cbxSprache.ElementFont := efCSS;
    cbxSprache.HeightStyle := ssAuto;
    cbxSprache.HeightPercent := 100.000000000000000000;
    cbxSprache.WidthPercent := 100.000000000000000000;
    SetEvent(cbxSprache, Self, 'OnChange', 'cbxSpracheChange');
    cbxSprache.ItemIndex := -1;
    WebButton1.SetParentComponent(pnlLogin);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 208;
    WebButton1.Top := 158;
    WebButton1.Width := 56;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Barcode';
    WebButton1.ChildOrder := 8;
    WebButton1.ElementClassName := 'btn btn-light';
    WebButton1.ElementFont := efCSS;
    WebButton1.HeightStyle := ssAuto;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.Visible := False;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WaitMessage.Left := 377;
    WaitMessage.Top := 193;
    BitmapCont.Left := 377;
    BitmapCont.Top := 224;
    tabSprachDaten.Left := 376;
    tmrLoginStart.SetParentComponent(Self);
    tmrLoginStart.Name := 'tmrLoginStart';
    tmrLoginStart.Enabled := False;
    SetEvent(tmrLoginStart, Self, 'OnTimer', 'tmrLoginStartTimer');
    tmrLoginStart.Left := 360;
    tmrLoginStart.Top := 24;
  finally
    pnlLogin.AfterLoadDFMValues;
    lbBenutzer.AfterLoadDFMValues;
    lbPasswort.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    editUsername.AfterLoadDFMValues;
    editPassword.AfterLoadDFMValues;
    cbxUserMerken.AfterLoadDFMValues;
    btnLogin.AfterLoadDFMValues;
    cbxSprache.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WaitMessage.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    tmrLoginStart.AfterLoadDFMValues;
  end;
end;

end.
